import { Fragment, type PropsWithChildren, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export function ResettablePage({ children }: PropsWithChildren) {
  const location = useLocation();
  const [key, setKey] = useState(Math.random().toString(36));

  const resetStates = () => {
    setKey(Math.random().toString(36)); // Change key to force remount
  };

  useEffect(() => {
    if (location.state?.resetPage) {
      resetStates();
    }
  }, [location.state]);

  return <Fragment key={key}>{children}</Fragment>;
}
